import Country from '@/domain/country/country.entity';

export default class Customer {
  id: string;

  name: string;

  externalId: string;

  document: string;

  createdAt: string;

  createdBy: string;

  tradingName: string;

  city: string;

  state: string;

  country: Country;

  email: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.externalId = obj.externalId || '';
    this.document = obj.document || '';
    this.createdAt = obj.createdAt || '';
    this.createdBy = obj.createdBy || '';
    this.tradingName = obj.tradingName || '';
    this.city = obj.city || '';
    this.state = obj.state || '';
    this.country = obj.country || null;
    this.email = obj.email || '';
  }

  public static of(obj: any): Customer {
    return new Customer(obj || {})
  }

  public static ofList(obj: any = []): Customer[] {
    return obj.map(this.of)
  }
}
